import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n';
import { Link } from 'react-router';
import { FlexCol } from '../../../Defaults/Flexbox/Flexbox';
import { FormInput } from '../../Form/FormInput';
import { prop } from '../../../../utilities';

interface Props {
  company: any;
  onBlur: () => void;
  isVisible: boolean;
  problems: any;
  onChange: (e) => void;
  isB2b: boolean;
}

function CompanyInfo({
  company,
  onChange,
  onBlur,
  isVisible,
  problems,
  isB2b,
}: Props) {
  const { companyName, ico, dic, ic_dph } = company;

  if (!isVisible) {
    return <EmptyWrapper />;
  }

  const { nameProblem, icoProblem, dicProblem, icDphProblem } = {
    nameProblem: prop(problems, 'name'),
    icoProblem: prop(problems, 'ico'),
    dicProblem: prop(problems, 'dic'),
    icDphProblem: prop(problems, 'ic_dph'),
  };

  return (
    <Wrapper>
      {!isB2b && (
        <Label>
          {__(
            `Chcete lepšie ceny ? V prípade, že ste podnikateľ alebo právnická osoba a plánujete opakované nákupy, zašlite nám prosím žiadosť o registráciu - `,
          )}
          <Link to={__r('routes:registracia-b2b', '/registracia-b2b')}>
            {__(`odkaz na registračný formulár`)}
          </Link>
          {__(
            `. Následne vás budeme kontaktovať a vytvoríme vám prístup, aby ste získali lepšie ceny, urýchlili svoje nákupy a mohli využívať aj ďalšie výhody nášho e-shopu.`,
          )}
        </Label>
      )}
      <FormInput
        name={'company.name'}
        type="text"
        label={'Firma'}
        defaultValue={companyName}
        required={true}
        onChange={onChange}
        onBlur={onBlur}
        validMessage={nameProblem}
      />
      <FormInput
        name={'company.ico'}
        type="text"
        required={true}
        label={'IČO'}
        defaultValue={ico}
        onChange={onChange}
        onBlur={onBlur}
        validMessage={icoProblem}
      />
      <FormInput
        name={'company.dic'}
        type="text"
        required={true}
        label={'DIČ'}
        defaultValue={dic}
        onChange={onChange}
        onBlur={onBlur}
        validMessage={dicProblem}
      />
      <FormInput
        name={'company.ic_dph'}
        type="text"
        required={true}
        label={'IČ DPH'}
        defaultValue={ic_dph}
        marginBottom={0}
        onChange={onChange}
        onBlur={onBlur}
        validMessage={icDphProblem}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  margin: ${rem(32)} 0;
`;

const EmptyWrapper = styled.div`
  margin-bottom: ${rem(24)};
`;

const Label = styled.span`
  color: black;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  font-weight: 400;
  margin-bottom: ${rem(16)};
`;

export { CompanyInfo };
